import { render, staticRenderFns } from "./SettingsDrawer.vue?vue&type=template&id=7acf0a36"
import script from "./SettingsDrawer.vue?vue&type=script&lang=ts"
export * from "./SettingsDrawer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports